<template>
  <div>
    <div v-if="mostrarMensagem === 'SIM'" class="alert alert-dismissible alert-warning" id="quandroAviso">
      <h4 align="center">COMUNICADO FBB</h4>
      <span v-html=mensagem></span>
    </div>
  <!-- Novembro Azul: fundo e logo no Azul claro do manual BB (#54DCFC) a 10% e 50%
       sobre o branco, destaques no Azul BB, o mesmo da marca. Em dezembro, reverter. -->
  <div class="pagina-login pagina-novembro-azul">
  <div class="login-box">
    <div class="login-logo yellow-bg">
      <router-link to="/" class="marca-novembro-azul">
        <img src="/static/img/logo-login.png" alt="Fundação BB" class="marca">
        <img src="/static/img/laco-novembro-azul.svg" alt="Novembro Azul" title="Novembro Azul: prevenção ao câncer de próstata" class="laco">
      </router-link>
    </div>
    <!-- /.login-logo -->
    <div class="login-box-body">
      <p class="login-box-msg">Entre com suas credenciais</p>
      <form @submit.prevent="login" @keydown="form.onKeydown($event)">

        <div v-if='error' class="alert alert-danger">
          <a class="close" data-dismiss="alert">&times;</a>
          {{ error }}
        </div>

        <div class="form-group required" :class="{ 'has-error' : form.errors.has('ds_login')}">
          <input type="text" class="form-control"
                 placeholder="Informe seu Login ou E-mail"
                 name="usuario"
                 v-model="form.ds_login"
                 v-validate="'required'"
          >
          <has-error :form="form" field="ds_login"></has-error>
          <span v-if="errors.first('usuario')" class="label label-danger"> {{ errors.first('usuario') }}</span>

        </div>

        <div class="form-group required" :class="{ 'has-error' : form.errors.has('senha')}">
          <input type="password" class="form-control"
                 :class="{'input': true, 'is-danger': errors.has('senha') }"
                 placeholder="Senha"
                 v-model="senha"
                 name="senha"
                 v-validate="'required'"
          >

          <span v-if="errors.first('senha')" class="label label-danger"> {{ errors.first('senha') }}</span>
        </div>
        <div align="center">
          <button :disabled="form.busy" type="submit" class="btn btn-primary-login btn-block btn-flat">Acessar</button>
        </div>

      </form>
      <br>
      <div align="center">
        <a id="recupera-senha" href="/esqueci-minha-senha"><span style="color: #465eff; font-weight: bold;">Esqueci minha senha</span></a>
      </div>
      <br>
      <div align="center">
      <a id="recupera-senha-msg" href="\static\img\help_senha_sgp.jpg" target="_"> <span style="color: #465eff"><i class="fa fa-question-circle" aria-hidden="true"></i>&nbsp Como recuperar minha senha?</span></a>
      </div>
    </div>
    <br>


    <vue-snotify></vue-snotify>
    <div style="color: white; text-align: center; padding: 10px; background-color: #465eff; width:360px; margin: 0 auto 0 auto;">
          <p>Ao acessar o SGP, você está concordando com o <a style="color: #fff; font-weight: bold; text-decoration: underline;" target="_blank" href="https://fbb.org.br/wp-content/uploads/2024/11/Programa_de_Compliance_e_Integridade_Fundacao_BB.pdf">Programa de <i>Compliance</i> e Integridade</a> e o <a style="color: #fff; font-weight: bold; text-decoration: underline;" target="_blank" href="https://fbb.org.br/wp-content/uploads/2024/11/Codigo_de_Etica_Fundacao_BB.pdf">Código de Ética</a> da Fundação BB.</p>
    </div>
  </div>
  </div>

  </div>

</template>

<script>
  /* eslint-disable no-unused-vars */

  // import axios from 'axios'
  import Msg from '../.././mensagem_sistema.json'
  import CryptoJS from 'crypto-js'
  import { salvaSessao, limpaSessao } from '../auth'

  export default {
    name: 'Login',
    components: {
      Msg
    },
    data: function () {
      return {
        // Create a new form instance
        form: new Form({
          ds_login: '',
          senha: ''
        }),
        senha: null,
        mensagem: '',
        credentials: {
          username: '',
          password: ''
        },
        error: ''
      }
    },
    beforeMount () {
      this.mensagem = Msg.texto
      this.mostrarMensagem = Msg.ativo
    },
    methods: {
      carregaMensagem () {
      },
      login: function () {
        var store = this.$store
        var credentials = {
          username: this.form.ds_login,
          password: this.form.senha
        }
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            await this.loginLaravel()
          }
        })
      },
      async loginLaravel () {
        // Chama o back end no Laravel para autenticação
        this.form.senha = CryptoJS.AES.encrypt(this.senha, 'ARtAVARECtoxYGoBsTaBLETeRanTedErEVoLIcHOlsTacKysTERSpERnaPHiCEnEthi').toString()
        // Save to local storage as well
        await this.form.post(process.env.BASEURLLARAVEL + 'auth/login').then((response) => {
          // Grava a autenticação no Vuex
          this.$store.commit('SET_USER_LARAVEL', response.data)
          if (window.localStorage) {
            // Grava token, refresh token, usuário e permissões, e já aplica o
            // header de Authorization no axiosLaravel (ver src/auth.js).
            limpaSessao()
            salvaSessao(response.data)
            this.$router.push('/dashboard')
          }
        })
          .catch((error) => {
            console.log('error', error)
            // O backend pode retornar a mensagem de erro como string crua (ex.: 401 "Usuário ou senha incorretos")
            // ou como objeto { message: ... } / { error: ... }. Trata todos os formatos para não exibir o quadro vazio.
            const data = error.response && error.response.data
            this.error = (typeof data === 'string' && data)
              ? data
              : (data && (data.message || data.error)) || 'Não foi possível efetuar o login. Tente novamente.'
            this.$snotify.error(this.error)
          })
      }
    },
    mounted: function () {
      this.carregaMensagem()
      // Suporte 76323 / RVS20240007383: aqui havia require('icheck') + $('input').iCheck({...}),
      // removidos por serem código morto. O iCheck só atua em input[type=checkbox] e
      // input[type=radio] (ver a variavel handle no icheck.js) e esta tela tem apenas os campos
      // de usuário e senha — nenhum checkbox ou radio. O CSS do skin (icheckbox_square-blue)
      // também nunca foi importado em lugar nenhum do projeto. Era o único consumidor do
      // pacote icheck, que saiu junto do package.json.
    }
  }
</script>

<style>
  html {
    height: 100%;
  }
  body{
    height: 100%;
    /*background-color: #0161AB !important;*/
    background-image: url("/static/img/background.jpg") !important;
  }
  /*
   * Page: Login & Register
   * ----------------------
   */
  .login-logo,
  .register-logo {
    font-size: 35px;
    text-align: center;
    margin-bottom: 0px !important;
    font-weight: 300;
  }
  .login-logo a,
  .register-logo a {
    color: #444;
  }
  .login-page,
  .register-page {
    background: #d2d6de;
  }
  .login-box,
  .register-box {
    width: 360px;
    margin: 0 auto !important;
    padding: 7% 0 0 0;
  }
  @media (max-width: 480px) {
    .login-box,
    .register-box {
      width: 90%;
      margin-top: 20px;
    }
  }
  .login-box-body,
  .register-box-body {
    background: #fff;
    padding: 20px;
    border-top: 0;
    color: #666;
  }
  .login-box-body .form-control-feedback,
  .register-box-body .form-control-feedback {
    color: #777;
  }
  .login-box-msg{
    margin: 0;
    text-align: center;
    padding: 0 20px 20px 20px;
  }
  .yellow-bg {
    background-color: #FCFC30;
    margin-bottom: 0px;
    margin-top: 55px;
    z-index: 3;
    position: relative;
  }

  .btn-primary {
    background-color: #002d4b !important;
    border-color: #002d4b;
  }
  .btn-primary-login {
    background-color: #002d4b !important;
    border-color: #002d4b;
    color: #fff;
  }
  button.btn-primary-login:hover, button.btn-primary-login:active {
    color: #fff;
    opacity: 0.9 ;
  }
  .has-feedback .form-control {
    padding-right: 42.5px;
  }

  /* Formulário centralizado na tela, nos dois eixos. Os recuos do topo
     (padding da .login-box e margin da .yellow-bg) eram o que o posicionava. */
  .pagina-login {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
  }
  body .pagina-login .login-box {
    padding: 0;
    margin: 0 !important;
  }
  body .pagina-login .login-box .login-logo.yellow-bg {
    margin-top: 0;
  }

  /* Novembro Azul. O fundo fica no wrapper, não no body: este <style> é global e
     o body continuaria azul nas telas logadas depois do login. */
  .pagina-novembro-azul {
    background-color: #eefcff;
  }
  body .pagina-novembro-azul .login-box .login-logo.yellow-bg {
    background-color: #aaeefe;
    text-shadow: none;
  }
  .marca-novembro-azul {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  /* 260px: a proporção do logo-login.png (300 × 81) em 70px de altura. */
  .marca-novembro-azul .marca {
    display: block;
    width: 260px;
    height: 70px;
  }
  .marca-novembro-azul .laco {
    width: 32px;
    height: 48px;
  }
  body .pagina-novembro-azul .btn-primary-login {
    background-color: #465eff !important;
    border-color: #465eff;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?8ce65cb6